import React from 'react';
import { Grid, Box, Typography, Divider, alpha, useTheme } from '@mui/material';
import { StyledCard, StyledCardHeader, StyledCardContent, MetricChip, formatDisplayItem } from '@features/analysis/components/StyledComponents';
import { ValuationInsightsCardProps } from '@features/analysis/types';

const ValuationInsightsCard: React.FC<ValuationInsightsCardProps> = ({ analysis }) => {
  const theme = useTheme();

  return (
    <StyledCard>
      <StyledCardHeader
        title="Valuation Insights"
        subheader="Estimating the property's value"
      />
      <StyledCardContent>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: theme.palette.text.primary, mb: 2 }}>
              Estimated Value:
            </Typography>
            <Box
              sx={{
                p: 3,
                borderRadius: 2,
                bgcolor: alpha(theme.palette.background.default, 0.5),
                border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                <Typography variant="body1" color="text.secondary">
                  Low Estimate:
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 600, color: theme.palette.success.dark }}>
                  ${analysis.valuationInsights?.estimatedValue?.low?.toLocaleString() ?? 'N/A'}
                </Typography>
              </Box>
              <Divider sx={{ my: 1 }} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body1" color="text.secondary">
                  High Estimate:
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 600, color: theme.palette.info.dark }}>
                  ${analysis.valuationInsights?.estimatedValue?.high?.toLocaleString() ?? 'N/A'}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: theme.palette.text.primary, mb: 2 }}>
              Value Drivers:
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {analysis.valuationInsights?.valueDrivers && analysis.valuationInsights.valueDrivers.length > 0 ? (
                [...analysis.valuationInsights.valueDrivers].map((driver, index) => (
                  <MetricChip key={`${index}-valuedriver`} label={formatDisplayItem(driver)} color="default" variant="outlined" sx={{ fontWeight: 500 }} />
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No value drivers listed.
                </Typography>
              )}
            </Box>
          </Grid>
        </Grid>
      </StyledCardContent>
    </StyledCard>
  );
};

export default ValuationInsightsCard;